import React from 'react';
import LocationTemplate from './LocationTemplate';

const GoldPointPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Gold Point"
      stateName="North Carolina"
      countyName="Martin"
      zipCodes={["27836"]}
      latitude={35.8843}
      longitude={-77.288}
      population={63}
      historicalFact="Tiny incorporated town in Martin County."
      nearbyTowns={[
        "Robersonville, NC",
        "Hamilton, NC",
        "Oak City, NC",
        "Williamston, NC",
        "Scotland Neck, NC",
        "Hassell, NC",
        "Plymouth, NC",
        "Windsor, NC"
      ]}
    />
  );
};

export default GoldPointPage;